<template>
  <v-toolbar
    app
    dense=""
    dark
    fixed
    color="primary"
    clipped-left
    flat>
    <v-toolbar-side-icon @click.stop="toggleSidebar" class="hidden-md-and-up"></v-toolbar-side-icon>
    <v-toolbar-title class="ml-0">
      <router-link :to="{name: 'dashboard'}" style="cursor: pointer;" tag="span">
        <v-img :src="require('@/assets/ntd-no-text.svg')" style="width: 50px;"></v-img>
      </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items class="hidden-sm-and-down">
      <v-btn
        v-for="link in editedLinks"
        :key="link.to"
        :to="{name: link.to}"
        @click="_toggleSidebar(false)"
        flat>
        <v-icon left>{{link.icon}}</v-icon>
        {{link.title}}
      </v-btn>
    </v-toolbar-items>
    <!--<v-menu bottom offset-y>-->
    <!--<v-btn icon large slot="activator">-->
    <!--<v-badge color="accent" overlap>-->
    <!--<span slot="badge" small>3</span>-->
    <!--<v-icon>-->
    <!--mdi-bell-->
    <!--</v-icon>-->
    <!--</v-badge>-->
    <!--</v-btn>-->
    <!--<notifications-dropdown/>-->
    <!--</v-menu>-->
    <v-toolbar-items style="margin-right: -6px;">
      <v-menu bottom offset-y>
        <v-btn icon slot="activator">
          <v-avatar
            color="accent"
            size="36">
            <span class="white--text headline">{{_avatar}}</span>
          </v-avatar>
        </v-btn>
        <user-menu/>
      </v-menu>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import userMenu from 'app/user/components/UserMenu'

export default {
  name: 'navbar',

  components: {
    userMenu
  },
  data () {
    return {
      title: 'НТ'
    }
  },

  computed: {
    ...mapGetters('tradle', {
      _links: 'links',
      _sidebarState: 'sidebarState'
    }),
    ...mapGetters('user', {
      _user: 'user',
      _avatar: 'avatar',
      _showBalance: 'showBalance'
    }),
    editedLinks () {
      if (!this._showBalance) {
        return this._links.filter((link) => link.to !== 'balance')
      } else {
        return this._links
      }
    }
  },

  methods: {
    ...mapActions('tradle', {
      _toggleSidebar: 'toggleSidebar'
    }),
    toggleSidebar () {
      this._toggleSidebar(!this._sidebarState)
    }
  }
}
</script>

<style scoped>

</style>
